__turbopack_context__.v({
  "asset": "qR7LsG_asset",
  "container": "qR7LsG_container",
  "firstStep": "qR7LsG_firstStep",
  "hideBorder": "qR7LsG_hideBorder",
  "rightColumn": "qR7LsG_rightColumn",
  "stepContent": "qR7LsG_stepContent",
  "stepNumber": "qR7LsG_stepNumber",
});
